var _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1185_7370",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.00004C2.89647 -0.666628 9.10353 -0.666704 12 5.99996C9.10353 12.6666 2.89647 12.6667 0 6.00004Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.00004L-0.917175 5.60155L-1.0903 6.00004L-0.917175 6.39852L0 6.00004ZM12 5.99996L12.9172 6.39845L13.0903 5.99996L12.9172 5.60148L12 5.99996ZM0.917175 6.39852C2.27329 3.27722 4.26622 2.00001 6.00001 2C7.73379 1.99999 9.72671 3.27715 11.0828 6.39845L12.9172 5.60148C11.3768 2.05611 8.81798 -2.3365e-05 5.99999 1.78814e-07C3.18201 2.37226e-05 0.623182 2.05619 -0.917175 5.60155L0.917175 6.39852ZM-0.917175 6.39852C0.623184 9.94389 3.18202 12 6.00001 12C8.81798 12 11.3768 9.94381 12.9172 6.39845L11.0828 5.60148C9.72671 8.72278 7.73378 9.99999 5.99999 10C4.26621 10 2.27329 8.72285 0.917175 5.60155L-0.917175 6.39852Z",
    fill: "black",
    mask: "url(#path-1-inside-1_1185_7370)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78097 5.99971C7.78097 6.98331 6.98361 7.78067 6.00001 7.78067C5.01642 7.78067 4.21906 6.98331 4.21906 5.99971C4.21906 5.01611 5.01642 4.21875 6.00001 4.21875C6.98361 4.21875 7.78097 5.01611 7.78097 5.99971Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.b6a366dbe89d15a99841479af9482cd3.svg";
export { ForwardRef as ReactComponent };